import {
  initializeFirebase,
  FirebaseAuth,
  FirebaseDatabase,
  FirestoreDatabase
} from 'refine-firebase';
import { getStorage } from 'firebase/storage';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export const firebaseConfig = {
  apiKey: "AIzaSyCwk8cHcIZABJD21AbE2cJMCh94xiV9j5s",
  authDomain: "olachat-fd889.firebaseapp.com",
  projectId: "olachat-fd889",
  storageBucket: "olachat-fd889.appspot.com",
  messagingSenderId: "261442225639",
  appId: "1:261442225639:web:80d458947893dca75ee942",
  measurementId: "G-SKM8EQ494Q"
};

export const firebaseApp = initializeFirebase(firebaseConfig);

export const firebaseAuth = new FirebaseAuth();

export const firestoreDatabase = new FirestoreDatabase();

export const firebaseDatabase = new FirebaseDatabase();

export const fbApp = initializeApp(firebaseConfig);
export const storage = getStorage(fbApp);

export const fbFirestore = getFirestore(fbApp);
export const fbAuth = getAuth(fbApp);
